import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  mainWrapper: {
    background: "inherit",
    display: "flex",
    flexDirection: "column",
    height: "100dvh",
    width: "100%",
  },
  contentWrapper: {
    background: "inherit",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    minHeight: 0,
    overflowY: "auto",
  },
});
